import React, {FC} from 'react';
import {useSelector} from 'react-redux';
import {legacyModalsApi, useModalsToggler} from '~/entities/dialogs';
import {RsnButton, RsnDialog} from '~/library/ui-kit';

const FinalRateModal: FC = () => {
    const finalRateModal = useSelector(legacyModalsApi.select('generalModals', 'finalRateModal'));
    const {changeFlag} = useModalsToggler('generalModals');

    const toggleModal = () => changeFlag('finalRateModal');
    return (
        <RsnDialog.Controller isOpen={finalRateModal} onClose={toggleModal}>
            <RsnDialog.Window placement='center'>
                <RsnDialog.CenteredHeader text='Final rate' />
                <RsnDialog.Body>
                    Final rate including the transaction fees is provided on the transaction screen after the exchange
                    is finished.
                </RsnDialog.Body>
                <RsnDialog.Footer>
                    <RsnButton.Secondary type='button' onClick={toggleModal}>
                        I got it
                    </RsnButton.Secondary>
                </RsnDialog.Footer>
            </RsnDialog.Window>
        </RsnDialog.Controller>
    );
};

export default FinalRateModal;
